// extracted by mini-css-extract-plugin
module.exports = {"detail":"PendingWithdrawalReferenceNumber_detail__nDICq","icon":"PendingWithdrawalReferenceNumber_icon__2LpcW","cancel":"PendingWithdrawalReferenceNumber_cancel__3sbyb"};